import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/mangas';

export default function LatestUpdates() {
  const list = [...mangas].sort((a, b) => a.updateTime.length - b.updateTime.length).slice(0, 6);
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-700">
            <i className="ri-send-plane-fill" /> 最新话推送
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950">最新更新，实时送达</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            订阅关注后，最新话内容将实时推送给你。这里是全站最近更新的连载，看看有没有你在追的作品。
          </p>
          <ul className="mt-6 space-y-3">
            {[
              { icon: 'ri-time-line', text: '更新时间实时同步' },
              { icon: 'ri-bell-fill', text: '按需订阅，零打扰' },
              { icon: 'ri-device-line', text: '多端同步追更记录' },
            ].map((f) => (
              <li key={f.text} className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={f.icon} />
                </span>
                {f.text}
              </li>
            ))}
          </ul>
          <Link
            to="/category/kehuan"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700"
          >
            去浏览全部连载 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {list.map((m) => (
              <Link
                key={m.id}
                to={`/category/${m.categoryId}`}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-accent-300"
              >
                <img
                  src={m.cover}
                  alt={`${m.title} 最新章节封面`}
                  className="h-24 w-[72px] shrink-0 rounded-md object-cover object-top"
                />
                <div className="min-w-0">
                  <h3 className="truncate text-sm font-bold text-foreground-950">{m.title}</h3>
                  <p className="mt-1 truncate text-xs text-foreground-600">{m.latestChapter}</p>
                  <p className="mt-2 inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700">
                    <i className="ri-time-fill" /> {m.updateTime}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}